// Keeps the Meta ad click id on the order, so the server-side Purchase can be tied to the ad even when
// the buyer's browser blocks the pixel or Shopify loses the session (in-app browsers, Safari tracking prevention).
// 1. On every page: remember ?fbclid= (as an _fbc value) plus the _fbp cookie in localStorage for 7 days,
//    and set the _fbc cookie like Meta's own pixel would.
// 2. After anything is added to the cart: write them to the cart attributes (_fbc, _fbp, _fbclid, _landing).
//    Cart attributes end up on the order (note_attributes); the CAPI relay reads them in the orders/paid webhook.
(function () {
  if (window.__cClickIds) return;
  window.__cClickIds = true;
  var KEY = 'c_click_ids';
  var TTL = 7 * 24 * 3600 * 1000;
  var originalFetch = window.fetch;

  function cookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }
  function load() {
    try {
      var s = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (s && Date.now() - s.ts < TTL) return s;
    } catch (e) {}
    return {};
  }
  function save(s) { try { localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {} }

  var state = load();
  var fbclid = '';
  try { fbclid = new URLSearchParams(location.search).get('fbclid') || ''; } catch (e) {}
  if (fbclid && state.fbclid !== fbclid) {
    state = { fbclid: fbclid, fbc: 'fb.1.' + Date.now() + '.' + fbclid, ts: Date.now(), landing: (location.pathname + location.search).slice(0, 200) };
  }
  var fbcCookie = cookie('_fbc');
  if (fbcCookie) state.fbc = fbcCookie;
  else if (state.fbc) {
    try { document.cookie = '_fbc=' + state.fbc + '; path=/; max-age=7776000; SameSite=Lax'; } catch (e) {}
  }
  function readFbp() { var p = cookie('_fbp'); if (p) { state.fbp = p; save(state); } return state.fbp || ''; }
  readFbp();
  if (state.fbc || state.fbp) { state.ts = state.ts || Date.now(); save(state); }

  var lastSent = '';
  function writeToCart() {
    var fbp = readFbp();
    var attrs = {};
    if (state.fbc) attrs._fbc = state.fbc;
    if (fbp) attrs._fbp = fbp;
    if (state.fbclid) attrs._fbclid = state.fbclid;
    if (state.landing) attrs._landing = state.landing;
    var body = JSON.stringify({ attributes: attrs });
    if (!Object.keys(attrs).length || body === lastSent) return;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    originalFetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: body })
      .then(function (r) { if (r.ok) lastSent = body; })
      .catch(function () {});
  }

  var timer;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var result = originalFetch.apply(this, arguments);
    if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
      result.then(function (r) {
        if (!r.ok) return;
        clearTimeout(timer);
        timer = setTimeout(writeToCart, 800); // after the bundle gifts are added too
      }).catch(function () {});
    }
    return result;
  };

  // visitor already has a cart (came back, or added before this script existed): make sure it carries the ids
  if (state.fbc || state.fbp) {
    setTimeout(function () {
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      originalFetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (cart) { if (cart && cart.item_count > 0) writeToCart(); })
        .catch(function () {});
    }, 1500);
  }
})();
